
import { INotificationService } from '../services/NotificationService'
import Component from 'vue-class-component'
import Vue from 'vue'
import RoleTemplate from '../templates/roleTemplate'
import Role from '../models/role'
import RoleService from '../services/RoleService'
import Service from '../models/service'
import { Watch } from 'vue-property-decorator'
import ServiceService from '@/services/ServiceService'
import ErrorHandlerService from '@/services/ErrorHandlerService'
import CreateService from '../components/Services/CreateService.vue'
import CardTitle from '../components/Atomic/CardTitle.vue'
import BlueButton from '../components/Atomic/BlueButton.vue'
import GreenButton from '../components/Atomic/GreenButton.vue'
import RedButton from '../components/Atomic/RedButton.vue'
import BaseLayout from '../components/Layout/BaseLayout.vue'
import HelpTooltip from '../components/Atomic/HelpTooltip.vue'
import SearchField from '@/components/Atomic/SearchField.vue'
import Schools from '@/models/schools'
import { State } from 'vuex-class'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'

@Component({
  components: {
    ProgressLinear,
    BaseLayout,
    CreateService,
    CardTitle,
    BlueButton,
    GreenButton,
    RedButton,
    HelpTooltip,
    SearchField,
  },
})
export default class Services extends Vue {
  @State('user') public user!: any
  public show: boolean = false
  public checked: boolean[][] = [[], []]
  public roles: RoleTemplate[] = []
  private $notificationService!: INotificationService
  private errorHandlerService: ErrorHandlerService

  private services: Service[] = []
  private filteredRoles: RoleTemplate[] = []
  private filteredServices: Service[] = []
  private dialog: boolean = false
  private editDialog: object = {}
  private deleteDialog: boolean = false
  private search: string = ''
  private selectedEstablishmentId?: number = 0
  private schools: Schools[] = []
  private isLoading: boolean = false
  private tab: any = null
  private isVCardPending: boolean = false
  private isDeleteVCardPending: boolean = false
  private isButtonPending: boolean = false
  private isUpdatingCanAssign: string = ''
  private isUpdatingTargets: string = ''
  private isUpdatingRole: string = ''

  constructor() {
    super()
    this.errorHandlerService = new ErrorHandlerService()
  }

  public mounted() {
    this.initialize()
  }

  public hide() {
    this.dialog = false
  }

  @Watch('search')
  private filterServices() {
    this.filteredServices = this.services.filter((service) => {
      if (!this.search) {
        return true
      }
      if (service.name.toLowerCase().includes(this.search.toLowerCase())) {
        return true
      }
    })
  }

  private initialize() {
    this.selectedEstablishmentId = undefined
    this.filteredRoles = []
    this.getSchools()
    this.fetchServices()
    this.fetchRoles()
  }

  private async fetchServices() {
    try {
      this.services = await ServiceService.get()
      this.filteredServices = this.services
    } catch (error: any) {
      if (error.response !== undefined) {
        this.errorHandlerService.handle(this, error.response.data.code, true)
      }
    }
  }

  private async fetchRoles() {
    try {
      RoleService.get().then((res: Role[]) => {
        res.forEach((r: Role) => {
          this.roles.push(new RoleTemplate(r))
        })
      })
    } catch (error: any) {
      if (error.response !== undefined) {
        this.errorHandlerService.handle(this, error.response.data.code, true)
      }
    }
  }

  private clearDataTable() {
    this.roles = []
    this.filteredRoles = []
    this.search = ''
  }

  private cancelDialog(service: Service) {
    this.$set(this.editDialog, service.groupe_ad_id, false)
    this.fetchServices()
  }

  private async updateService(service: Service) {
    this.isVCardPending = true
    try {
      const result = await ServiceService.update(service, service.groupe_ad_id)
      this.$set(this.editDialog, service.groupe_ad_id, false)
      this.$notificationService.success(
        this.$t('SERVICES.UpdateServiceSuccess').toString() + ' ' + service.name,
      )
    } catch (error: any) {
      this.$notificationService.error(
        this.$t('SERVICES.UpdateServiceFailed').toString() + '' + service.name,
      )
    } finally {
      this.isVCardPending = false
    }
  }

  private async createService(service: Service) {
    try {
      const result = await ServiceService.create(service)
      this.services.push(result)
      this.$notificationService.success(
        this.$t('SERVICES.CreationServiceSuccess').toString(),
      )
    } catch (error: any) {
      this.$notificationService.error(
        this.$t('SERVICES.CreationServiceFailed').toString(),
      )
    }
  }

  private async deleteService(service: Service) {
    this.isDeleteVCardPending = true
    try {
      const result = await ServiceService.delete(service.groupe_ad_id)
      this.$notificationService.success(
        this.$t('SERVICES.DeleteService').toString() +
          service.name +
          this.$t('SERVICES.DeleteServiceSuccess').toString(),
      )
      this.deleteDialog = false
      this.editDialog = {}
    } catch (error: any) {
      this.$notificationService.error(
        this.$t('SERVICES.DeleteService').toString() +
          service.name +
          this.$t('SERVICES.DeleteServiceFailed').toString(),
      )
    } finally {
      this.initialize()
      this.isDeleteVCardPending = false
    }
  }

  private getSchools() {
    this.isLoading = true
    this.schools = Object.assign([], this.user.schools)
    this.schools.unshift({ etablissement_id: -2, nom: 'Globaux' })
    this.isLoading = false
  }

  private getSchoolName(school_id: number) {
    if (school_id !== -2) {
      const schoolObject = this.schools.find(
        (school) => school.etablissement_id === school_id,
      )
      if (schoolObject) {
        return schoolObject.nom
      }
    }
  }

  private async onSelectedEstablishmentIdChanged(schoolID: number) {
    this.roles = []
    this.filteredRoles = []
    if (schoolID) {
      await RoleService.getForSchool(schoolID).then((res: Role[]) => {
        res.forEach((r: Role) => {
          this.roles.push(new RoleTemplate(r))
          this.filteredRoles.push(new RoleTemplate(r))
        })
      })
    }
    this.filterRole()
  }

  private filterRole() {
    this.filteredRoles = this.roles.filter((role) => {
      if (!this.search) {
        return true
      }
      if (role.name.toLowerCase().includes(this.search.toLowerCase())) {
        return true
      }
      if (role.schoolId) {
        if (role.schoolId.toString().includes(this.search.toLowerCase())) {
          return true
        }
        const schoolName = this.getSchoolName(role.schoolId)
        if (schoolName) {
          if (schoolName.toLowerCase().includes(this.search.toLowerCase())) {
            return true
          }
        }
      }
    })
  }

  private get getNumberOfItemsPerSize() {
    if (this.$vuetify.breakpoint.xlOnly) {
      return 10
    }
    if (this.$vuetify.breakpoint.lgOnly) {
      return 6
    }
    if (this.$vuetify.breakpoint.mdOnly) {
      return 3
    }
    return 2
  }

  private async changeAssignement(
    service: Service,
    role: Role,
    action: string,
  ) {
    this.isButtonPending = true
    switch (action) {
      case 'canAssign':
        this.isUpdatingCanAssign = service.name
        const arrayIndexCanAssign: number = service.can_assign.indexOf(
          role.name,
        )
        if (arrayIndexCanAssign !== -1) {
          service.can_assign.splice(arrayIndexCanAssign, 1)
        } else {
          service.can_assign.push(role.name)
        }
        break
      case 'canBeTarget':
        this.isUpdatingTargets = service.name
        const arrayIndexTargets: number = service.targets.indexOf(role.name)
        if (arrayIndexTargets !== -1) {
          service.targets.splice(arrayIndexTargets, 1)
        } else {
          service.targets.push(role.name)
        }
        break
    }
    this.isUpdatingRole = role.name
    await this.updateService(service)
    this.resetIsUpdating()
    await this.fetchServices()
    this.filterRole()
    this.isButtonPending = false
  }

  private resetIsUpdating() {
    this.isUpdatingCanAssign = ''
    this.isUpdatingTargets = ''
    this.isUpdatingRole = ''
  }
}
